const color = {
    black: '#0b0c0c',
    'dark-grey': '#505a5f',
    'mid-grey': '#b1b4b6',
    'light-grey': '#f3f2f1',
    white: '#ffffff',

    red: '#d4351c',
    yellow: '#ffdd00',
    green: '#00703c',
    'light-blue': '#5694ca',
    blue: '#1d70b8',
    'dark-blue': '#003078',
    purple: '#4c2c92',

    'light-purple': '#6f72af',
    'bright-purple': '#912b88',
    pink: '#d53880',
    'light-pink': '#f499be',
    orange: '#f47738',
    brown: '#b58840',
    'light-green': '#85994b',
    turquoise: '#28a197'
};

export default color;
